import { useEffect } from 'react';
import Index from '@/pages/index';
import { setLanguage } from 'react-switch-lang';

export default function En() {
	const lang = 'en';
	useEffect(
		() => {
			document.documentElement.lang = lang;
		},
		[ lang ]
	);
	setLanguage('en');
	return <Index />;
}
